
export default class Configurator {

    configuratorForm = document.querySelector('.jsConfiguratorForm')
    contactFormField = document.querySelector('#input_1_13');
    allOptions = [...this.configuratorForm.querySelectorAll('.configurator__option-select')];

    init() {
        this.events();
        this.filterOptions();
    }

    events() {
        this.configuratorForm.addEventListener('change', (e) => {
            this.filterOptions();
            this.deselectIllegalOptions();
            this.recalculateConfiguratorPrice()
            this.showProductComment(e.target.closest('.jsConfiguratorOption'))
            this.updateContactForm()
        })
    }

    prepareFormData(qty) {
        const productId = this.configuratorForm.dataset.productid;
        const products = [...this.allOptions.map(option => ({productId: option.value, qty: Number(option.options[option.selectedIndex].dataset.qty)}) ), {productId, qty}];

        return products.filter(item => item.productId !== '')
    }

    filterOptions() {
        const allProducts = this.configuratorForm.querySelectorAll('option');
        const curentConfiguration = this.prepareFormData(1);

        allProducts.forEach(product => {
            const requiredProducts = product.dataset.requiredProducts;
            const requiredQty = product.dataset.requiredProductsQty ?? 1;

            if(!requiredProducts) return;

            const products = requiredProducts.split(',');

            const requirementCheck = curentConfiguration.filter(x => products.includes(x.productId) && x.qty == requiredQty);

            if(requirementCheck.length) {
                product.classList.remove('hidden');
                return;
            };

            product.classList.add('hidden');
        })
    }

    deselectIllegalOptions() {
        this.allOptions.forEach(select => {
            const selectedIndex = select.selectedIndex;
            if([...select.options[selectedIndex].classList].includes('hidden')) {
                select.selectedIndex = 0;
            }
        })
    }

    recalculateConfiguratorPrice() {
        const dataForm = this.prepareFormData(1);

        fetch(window.app_global.ajax_url + "?action=calculateConfiguratorPrice", {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            redirect: "follow",
            referrerPolicy: "no-referrer",
            headers: {
                "Content-type": "application/json"
            },
            body: JSON.stringify(dataForm),
        })
            .then((response) => response.json())
            .then((response) => {
                const { price, lowestPrice, deliveryDate } = response.data;
                try {
                    document.querySelector(".jsConfiguratorPrice").innerHTML = price;
                    document.querySelector(".jsLowestPrice").innerHTML = lowestPrice;
                    document.querySelector(".jsDeliveryDate").innerHTML = deliveryDate;
                }catch{}
            });
    }

    showProductComment(step) {
        const select = step.querySelector('.jsConfiguratorSelect');
        const comments = step.querySelectorAll('.jsConfiguratorComment');
        const selectedProductId = select.value;

        comments.forEach(comment => {
            const productId = comment.dataset.productid;

            if(selectedProductId == productId) {
                comment.classList.add('configurator__option-comment--active')
                return;
            }

            comment.classList.remove('configurator__option-comment--active')
        });
    }

    validate() {
        let isValid = true;
        const allOptions = [...this.configuratorForm.querySelectorAll('.configurator__option-select')];
        allOptions.forEach(option => {
            if(!option.required) return;

            if(option.value == '') {
                option.classList.add('invalid')
                isValid = false;
            }
            else {
                option.classList.remove('invalid')
            }
        })

        return isValid;
    }

    updateContactForm() {

        const productTitle = document.querySelector('.single-product__title--main').innerText;
        const allOptions = [...this.configuratorForm.querySelectorAll('.configurator__option-select')];

        const configuration = allOptions.map(option => {
            const step = option.parentNode;
            const label = step.querySelector('.configurator__option-label').innerText;
            return ` ${label}: ${option.selectedOptions[0].text == 'Wybierz' ? 'Niewybrane' : option.selectedOptions[0].text}`;
        })

        this.contactFormField.value = `${productTitle}\r\n\r\nKonfiguracja:\r\n${configuration.join("\r\n")}`;
    }
}